import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import { appointmentView } from '../../Context/api';
import axios from 'axios';
import { statusCodes } from '../../Constants/generalConfig';
import { useEffect } from 'react';
import moment from 'moment'
import Spinner from '../Spinner/spinner';

const AppointmentView = () => {
    const [appointmentViewData, setAppointmentViewData] = useState([])
    const { appointmentId, createdbyId } = useParams()
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    useEffect(() => {
        appointmentViews()
    }, [])

    const appointmentViews = () => {
        setSpinner(true)
        axios.post(appointmentView(), { loggedInUserId: createdbyId, appointmentId: appointmentId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setAppointmentViewData(resp.data.data)
                setSpinner(false)
            }
            else {
                setSpinner(false)
            }
        })
    }
    return (
        <>
            {spinner ? <Spinner /> : null}
            {/* <section>
                <div className="m-t-3 cus-padd cusheight">
                    <header>
                        <h2 className='page-tittle'>
                            Appointment Summary
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4">
                        <div class="shadow-sm p-3 mb-2 bg-body-tertiary rounded row">
                            <div className="col-md-6">
                                <div className="mb-1">
                                    <label className="form-label">Client Name</label>
                                    <input type="text" className="form-control" value={appointmentViewData?.clientName} disabled={true} />
                                </div>
                            </div>
                            {
                                appointmentViewData.clientRole == 'MEMBER' ? null
                                    :

                                    <div className="col-md-6">
                                        <div className="mb-1">
                                            <label className="form-label">Mobile Number</label>
                                            <input type="text" className="form-control" value={appointmentViewData?.clientMoblieNo} disabled={true} />
                                        </div>
                                    </div>
                            }
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Appointment ID </label>
                                    <input type="text" className="form-control" value={appointmentViewData?.appointment_number} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Date</label>
                                    <input type="text" className="form-control" value={moment(appointmentViewData?.startDateTime).format('DD-MM-YYYY')} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Time</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={`${moment(appointmentViewData?.startDateTime).format('LT')} - ${moment(appointmentViewData?.endDateTime).format('LT')}`}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="shadow-sm p-3 mb-2 bg-body-tertiary rounded row">
                            <div className="col-md-6">
                                <div className="mb-1">
                                    <label className="form-label">Team Member</label>
                                    <input type="text" className="form-control" value={appointmentViewData?.staffName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-1">
                                    <label className="form-label">Branch</label>
                                    <input type="text" className="form-control" value={appointmentViewData?.branchName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Status</label>
                                    <input type="text" className="form-control" value={appointmentViewData?.reschedule?.status && appointmentViewData.status === 'CANCELLED' ? appointmentViewData?.status : appointmentViewData.status === 'PENDING' ? appointmentViewData?.status : appointmentViewData?.status == 'DECLINED' ? appointmentViewData?.status : appointmentViewData?.reschedule?.status ? 'RESCHEDULE' : appointmentViewData?.status} disabled={true} />
                                </div>
                            </div>
                        </div>
                        <div class="shadow-sm p-3 mb-5 bg-body-tertiary rounded row">
                            {
                                appointmentViewData?.MainOfferData?.length ?
                                    <div className="col-md-6">
                                        <label className="form-label">Offer & Service</label>
                                        <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #ced4da' }}>
                                            <div className='row text-start' >
                                                <div className="col-sm-3">Service</div>
                                                <div className="col-sm-3">Offer</div>
                                                <div className="col-sm-3">Actual Price</div>
                                                <div className="col-sm-3">Discount Price</div>
                                            </div>
                                            {

                                                appointmentViewData?.MainOfferData?.map((item, i) =>
                                                    <div className='row text-start' >
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{item?.serviceName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.offerName ? '--' : item?.offerName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.Amount ? '--' : `${item?.Amount}`}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.finalAmount ? '--' : `${item?.Amount - item?.finalAmount}`}</div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    :
                                    null

                            }
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Actual Price</label>
                                    <input type="text" className="form-control" value={`${appointmentViewData?.price}`} disabled={true} />
                                </div>
                            </div>

                            {
                                appointmentViewData?.AddonOfferData?.length ?
                                    <div className="col-md-6">
                                        <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #ced4da' }}>
                                            {

                                                appointmentViewData?.AddonOfferData?.map((item, i) =>
                                                    <div className='row text-start' >
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{item?.serviceName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.offerName ? '--' : item?.offerName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.Amount ? '--' : `${item?.Amount}`}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.finalAmount ? '--' : `${item?.Amount - item?.finalAmount}`}</div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    :
                                    null

                            }


                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Final Price</label>
                                    <input type="text" className="form-control" value={`${appointmentViewData?.amount}`} disabled={true} />
                                </div>
                            </div>

                            {appointmentViewData?.reschedule?.rescheduleByName && appointmentViewData.status === 'CANCELLED' || appointmentViewData?.status == 'DECLINED' ? null : appointmentViewData?.reschedule?.rescheduleByName ?
                                <div div className="col-md-6 mt-2">
                                    <div className="mb-1">
                                        <label className="form-label">Reschedule By</label>
                                        <input type="text" className="form-control" value={appointmentViewData?.reschedule?.rescheduleByName} disabled={true} />
                                    </div>
                                </div>
                                : null
                            }
                            {

                                appointmentViewData?.cancel?.reason ?
                                    <>
                                        <div className="col-md-6 mt-2">
                                            <div className="mb-1">
                                                <label className="form-label">Cancelled Reason</label>
                                                <textarea className="form-control" value={appointmentViewData?.cancel?.reason} disabled={true}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="mb-1">
                                                <label className="form-label">Cancelled By</label>
                                                <input type="text" className="form-control" value={appointmentViewData?.cancel?.userName} disabled={true} />
                                            </div>
                                        </div>
                                    </>
                                    : null

                            }
                        </div>

                    </form>
                </div>
            </section > */}

            <section>
                <div className="m-t-3 cus-padd cusheight">
                    <header>
                        <h2 className='page-tittle'>
                            Appointment Summary
                        </h2>
                        <hr />
                    </header>
                    <form className="row ps-4  mt-4">
                        <div class="shadow-sm py-3 mb-3 bg-body-tertiary rounded row">
                            <div className="col-md-6">
                                <div className="mb-1">
                                    <label className="form-label">Client Name</label>
                                    <input type="text" className="form-control " value={appointmentViewData?.clientName} disabled={true} />
                                </div>
                            </div>
                            {
                                appointmentViewData.clientRole === 'MEMBER' ? null
                                    :

                                    <div className="col-md-6">
                                        <div className="mb-1">
                                            <label className="form-label">Mobile Number</label>
                                            <input type="text" className="form-control " value={appointmentViewData?.clientMoblieNo} disabled={true} />
                                        </div>
                                    </div>
                            }
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Appointment ID </label>
                                    <input type="text" className="form-control " value={appointmentViewData?.appointment_number} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Date</label>
                                    <input type="text" className="form-control " value={moment(appointmentViewData?.startDateTime).format('DD-MM-YYYY')} disabled={true} />
                                </div>
                            </div>
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Time</label>
                                    <input
                                        type="text"
                                        className="form-control "
                                        value={`${moment(appointmentViewData?.startDateTime).format('LT')} - ${moment(appointmentViewData?.endDateTime).format('LT')}`}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            {
                                appointmentViewData?.notes ?
                                    <div className="col-md-6 mt-2">
                                        <div className="mb-1">
                                            <label className="form-label">Special Notes</label>
                                            <textarea className="form-control " value={appointmentViewData?.notes} disabled={true}></textarea>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                appointmentViewData?.remark ?
                                    <div className="col-md-6 mt-2">
                                        <div className="mb-1">
                                            <label className="form-label">Remark</label>
                                            <input
                                                type="text"
                                                className="form-control "
                                                value={appointmentViewData?.remark}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                        <div class="shadow-sm py-3 mb-3 bg-body-tertiary rounded row">
                            <div className="col-md-6">
                                <label className="form-label">Team Member</label>
                                <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #e9ecef', borderRadius: '5px', color: '#867d7d' }}>
                                    <ul className='mt-1 ms-1'>
                                        {
                                            appointmentViewData?.staffDetail?.map((item) =>
                                                <li class="list-group-item">{item.name}</li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-1">
                                    <label className="form-label">Branch</label>
                                    <input type="text" className="form-control " value={appointmentViewData?.branchName} disabled={true} />
                                </div>
                            </div>
                            {
                                appointmentViewData?.visitType ?
                                    <div className="col-md-6 mt-2">
                                        <div className="mb-1">
                                            <label className="form-label">Booking Type</label>
                                            <input type="text" className="form-control " value={appointmentViewData?.visitType} disabled={true} />
                                        </div>
                                    </div>
                                    : null

                            }
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Status</label>
                                    <input type="text" className="form-control " value={appointmentViewData?.reschedule?.status && appointmentViewData.status === 'CANCELLED' ? appointmentViewData?.status : appointmentViewData.status === 'PENDING' ? appointmentViewData?.status : appointmentViewData?.status === 'DECLINED' ? appointmentViewData?.status : appointmentViewData?.reschedule?.status ? 'RESCHEDULE' : appointmentViewData?.status} disabled={true} />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 shadow-sm py-3 mb-4 bg-body-tertiary rounded row">

                            {
                                appointmentViewData?.MainOfferData?.length ?
                                    <div className="col-md-6">
                                        <label className="form-label">Offer & Service</label>
                                        <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #e9ecef', boxShadow: '0px 1px 3px #fbbf9e' }}>
                                            <div className='row text-start' >
                                                <div className="col-lg-3">
                                                    <div className='col-lg-12'>Service</div>
                                                    {

                                                        appointmentViewData?.MainOfferData?.map((item, i) =>

                                                            <div className='col-lg-12' style={{ color: '#e9ecef', fontSize: '16px' }}>{item?.serviceName}</div>
                                                        )}
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className='col-lg-12'>Offer</div>
                                                    {

                                                        appointmentViewData?.MainOfferData?.map((item, i) =>
                                                            <div className='col-lg-12' style={{ color: '#e9ecef', fontSize: '16px' }}>{!item?.offerName ? '--' : item?.offerName}</div>
                                                        )}
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className='col-lg-12'>Actual Price</div>
                                                    {

                                                        appointmentViewData?.MainOfferData?.map((item, i) =>
                                                            <div className='col-lg-12' style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.Amount ? '--' : `${item?.Amount}`}</div>
                                                        )}
                                                </div>
                                                <div className="col-lg-3">
                                                    <div className='col-lg-12'>Discount Price</div>
                                                    {

                                                        appointmentViewData?.MainOfferData?.map((item, i) =>
                                                            <div className='col-lg-12' style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.finalAmount ? '--' : `${item?.Amount - item?.finalAmount}`}</div>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null

                            }
                            {
                                //    appointmentViewData?.isComboPackage &&
                                <div className="col-md-6">
                                    <label className="form-label">Service</label>
                                    <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #e9ecef', borderRadius: '5px', color: '#867d7d' }}>
                                        <ul className='mt-1 ms-1'>
                                            {
                                                appointmentViewData?.serviceDetail?.map((item) =>
                                                    <li class="list-group-item">{item.name}</li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            }



                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Actual Price</label>
                                    <input type="text" className="form-control " value={`${appointmentViewData?.price}`} disabled={true} />
                                </div>
                            </div>

                            {
                                appointmentViewData?.AddonOfferData?.length ?
                                    <div className="col-md-6">
                                        <div className='px-2' style={{ background: '#e9ecef', border: '1px solid #e9ecef'}}>
                                            {

                                                appointmentViewData?.AddonOfferData?.map((item, i) =>
                                                    <div className='row text-start' >
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{item?.serviceName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.offerName ? '--' : item?.offerName}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.Amount ? '--' : `${item?.Amount}`}</div>
                                                        <div className="col-sm-3" style={{ color: '#867d7d', fontSize: '16px' }}>{!item?.finalAmount ? '--' : `${item?.Amount - item?.finalAmount}`}</div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                    :
                                    null

                            }

                            {appointmentViewData?.reschedule?.rescheduleByName && appointmentViewData.status === 'CANCELLED' || appointmentViewData?.status === 'DECLINED' ? null : appointmentViewData?.reschedule?.rescheduleByName ?
                                <div div className="col-md-6 mt-2">
                                    <div className="mb-1">
                                        <label className="form-label">Reschedule By</label>
                                        <input type="text" className="form-control " value={appointmentViewData?.reschedule?.rescheduleByName} disabled={true} />
                                    </div>
                                </div>
                                : null
                            }
                            {
                                appointmentViewData?.cancel?.reason ?
                                    <>
                                        <div className="col-md-6 mt-2">
                                            <div className="mb-1">
                                                <label className="form-label">Cancelled Reason</label>
                                                <textarea className="form-control " value={appointmentViewData?.cancel?.reason} disabled={true}></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-6 mt-2">
                                            <div className="mb-1">
                                                <label className="form-label">Cancelled By</label>
                                                <input type="text" className="form-control " value={appointmentViewData?.cancel?.userName} disabled={true} />
                                            </div>
                                        </div>
                                    </>
                                    : null

                            }
                            <div className="col-md-6 mt-2">
                                <div className="mb-1">
                                    <label className="form-label">Final Price</label>
                                    <input type="text" className="form-control " value={`${appointmentViewData?.amount}`} disabled={true} />
                                </div>
                            </div>
                        </div>

                    </form>
                </div>





            </section>
        </>
    )
}

export default AppointmentView;